import { Info, useIntl } from '@capsicum/common';
import { Image } from '@capsicum/common-web';

import * as S from './AmlQuestionnaire.styled';

export const PepModal = () => {
	const { $t } = useIntl();

	return (
		<S.ModalWrapper>
			<Image alt="info-icon" height={126} src={Info} width={145} />
			<S.ModalTitle>{$t('amlQuestionnaire.fifthStep.pepModal.title')}</S.ModalTitle>
			<S.ModalDescription>{$t('amlQuestionnaire.fifthStep.pepModal.description')}</S.ModalDescription>
		</S.ModalWrapper>
	);
};
